/**
 * Tiny decorative glyphs for the ფრაზები album stickers (state marks).
 * Drawn as SVG in `currentColor` instead of emoji/text symbols so they look
 * the same on every phone. Always aria-hidden: each tile's aria-label says
 * its state.
 */

const PROPS = {
  width: '1em',
  height: '1em',
  viewBox: '0 0 16 16',
  'aria-hidden': true,
  focusable: false,
} as const;

/** A finished lesson — the gold tick on a stuck-on sticker. */
export function CheckGlyph() {
  return (
    <svg {...PROPS}>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.4 8.4 6.6 11.6 12.8 4.8"
      />
    </svg>
  );
}

/** A perfect run (golden). */
export function StarGlyph() {
  return (
    <svg {...PROPS}>
      <path
        fill="currentColor"
        d="M8 1.2 10.1 5.6 14.9 6.2 11.4 9.5 12.3 14.3 8 12 3.7 14.3 4.6 9.5 1.1 6.2 5.9 5.6Z"
      />
    </svg>
  );
}

/** Review lesson — a circular arrow. */
export function ReviewGlyph() {
  return (
    <svg {...PROPS}>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        d="M12.6 9.2A4.8 4.8 0 1 1 11 4.4"
      />
      <path fill="currentColor" d="M9.4 1.6 13.6 3.4 10.6 6.8Z" />
    </svg>
  );
}

/** Pro — a lightning bolt (white on the gold badge). */
export function BoltGlyph() {
  return (
    <svg {...PROPS}>
      <path fill="currentColor" d="M9.6 1 3.4 9.2h4L6.2 15l6.4-8.4H8.6Z" />
    </svg>
  );
}
